export enum ErrorType {
    FatalError,
    SessionTimeout,
    BeforeSendError,
}

export const isHappenedOtherPartyError = (resData: any): boolean => {
    return (
        resData === ErrorType.FatalError ||
        resData === ErrorType.SessionTimeout ||
        resData === ErrorType.BeforeSendError
    );
};
